<template>
  <div class="home">
    <v-container grid-list-md>
      <v-layout row justify-center>
        <v-flex xs12 md5>
          <v-layout column align-center justify-center>
            <v-flex mb-5 mt-5>
              <img :src="require('@/assets/hil-logo-text.png')" width="200px" />
            </v-flex>
            <v-flex v-if="loading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-flex>
            <v-flex v-else>
              <LoginForm v-if="isLogged === false" @login="redirect" />
              <div v-else>
                Connecté
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LoginForm from "../components/LoginForm";
import { mapActions, mapState } from "vuex";

export default {
  name: "home",
  components: {
    LoginForm
  },
  data() {
    return {
      loading: true
    };
  },
  async mounted() {
    await this.fetchStatus();
    console.log(this.$store.state);
    this.loading = false;
    if (this.isLogged) {
      this.redirect();
    }
  },
  methods: {
    ...mapActions("user", ["fetchStatus"]),

    redirect() {
      if (this.$route.params.prevRoute) {
        this.$router.push(this.$route.params.prevRoute);
      } else {
        this.$router.push("/sales");
      }
    }
  },
  computed: {
    ...mapState("user", ["isLogged"])
  }
};
</script>
<style scoped>
.home {
  background: #a5c3ff;
  height: 100vh;
}
</style>
